// ConfirmModal.tsx
import React from "react";
import ErrorBoundary from "../../ErrorBoundary";

interface ConfirmModalProps {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  isOpen: boolean;
  confirmText?: "Confirm" | "Cancel" | "Delete" | "Alert";
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  message,
  onConfirm,
  onCancel,
  isOpen,
  confirmText = "Confirm",
}) => {
  if (!isOpen) return null;

  return (
    <ErrorBoundary>
      <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50 px-3">
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
          <h2 className="text-lg font-bold mb-4">{confirmText}</h2>
          <p className="mb-6">{message}</p>
          <div
            className={
              confirmText === "Alert"
                ? "flex justify-end"
                : "flex justify-between space-x-4"
            }
          >
            {confirmText !== "Alert" && (
              <button
                className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                onClick={onCancel}
              >
                {confirmText === "Confirm" || confirmText === "Cancel"
                  ? "No"
                  : "Cancel"}
              </button>
            )}
            <button
              className={
                confirmText === "Delete" || confirmText === "Cancel"
                  ? "px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                  : "px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              }
              onClick={onConfirm}
            >
              {confirmText === "Confirm" || confirmText === "Cancel"
                ? "Yes"
                : confirmText === "Alert"
                ? "OK"
                : confirmText}
            </button>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default ConfirmModal;
